import { getEmptySlider, Slider, sliderFromResponse } from './Slider';
import { SliderSlide, sliderSlideFromResponse } from './SliderSlide';

export interface SliderDetails {
  slider: Slider;
  slides: SliderSlide[];
}

export const getEmptySliderDetails = (): SliderDetails => ({
  slider: getEmptySlider(),
  slides: [],
});

export const sliderDetailsFromResponse = (
  responseData: any,
): SliderDetails => ({
  slider: sliderFromResponse(responseData.slider),
  slides: (responseData.slides ?? []).map((slide: any) =>
    sliderSlideFromResponse(slide),
  ),
});
